export const getCaseIdFromUrl = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  const hash = window.location.hash || '';
  const hashRoute = hash.charAt(0) === '#' ? hash.slice(1) : hash;
  const hashMatch = hashRoute.match(/\/cases\/([^/?#]+)/i);
  if (hashMatch && hashMatch[1]) {
    return decodeURIComponent(hashMatch[1]);
  }

  const pathname = window.location.pathname || '';
  const pathMatch = pathname.match(/\/cases\/([^/?#]+)/i);
  if (pathMatch && pathMatch[1]) {
    return decodeURIComponent(pathMatch[1]);
  }

  return null;
};